import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqCategory {
  category: string;
  items: FaqItem[];
}

const faqCategories: FaqCategory[] = [
  {
    category: 'はじめての方へ',
    items: [
      {
        q: 'Golph.clubとはどんな施設ですか？',
        a: '大阪市住之江区にある、完全貸切・無人のシミュレーションゴルフ施設です。世界最高峰のUNEEKOR EYE XO2センサーを搭載し、1700以上のコースでプレーできます。60平米のブースを最大4名様まで貸切でご利用いただけます。',
      },
      {
        q: 'ゴルフ未経験・初心者でも利用できますか？',
        a: 'はい、可能です。初めての方にはインストラクターオプション（¥3,300/時間）をおすすめしています。機器の使い方や測定数値の見方を丁寧にお伝えします。',
      },
      {
        q: '会員登録は必要ですか？',
        a: 'はい。ビジター利用の場合も、無料の会員登録が必要です。',
      },
      {
        q: '会員登録はどこからできますか？',
        a: 'サイト内の「予約する」の先に進んだシステム内で登録が可能です。',
      },
      {
        q: '年齢制限はありますか？',
        a: '18歳未満の方は、保護者の方の同伴を必須とさせていただきます。',
      },
      {
        q: '子どもと一緒に利用できますか？',
        a: 'はい。キッズ用のレンタルクラブ（130cm以上のお子様用）もご用意しています。お子様もプレイの有無・年齢に関わらず人数にカウントされます。',
      },
    ],
  },
  {
    category: '料金・プランについて',
    items: [
      {
        q: 'どんな料金プランがありますか？',
        a: 'サブスクリプション（ライト会員・プレミアム会員）、回数券、ビジター（都度利用）の4種類があります。',
      },
      {
        q: 'ビジター利用（都度利用）の料金を教えてください。',
        a: '最大4名まで同一料金です。1時間 ¥5,000 / 2時間 ¥9,000 / 3時間 ¥13,000 / 4時間 ¥16,000。延長は+1時間につき¥5,000です。予約は前日〜当日の空き枠で可能です。',
      },
      {
        q: 'ビジターとサブスクの違いは何ですか？',
        a: 'ビジターは都度払いで、前日〜当日に予約します。サブスクは月額制でお得に利用でき、予約もより早く取れます（ライト：3日前〜、プレミアム：7日前〜）。定期的に通う方にはサブスクがおすすめです。',
      },
      {
        q: 'ライト会員とプレミアム会員の違いは？',
        a: 'ライト（¥9,900/月）：1名、55分、延長+1時間まで可、3日前から予約。プレミアム（¥16,900/月）：2名（本人＋同伴1名）、1時間55分、延長+2時間まで可、7日前から予約。定期的に通う方、お二人で利用される方にはプレミアムがおすすめです。',
      },
      {
        q: 'サブスク会員の同伴者の料金は？',
        a: 'ライト会員は基本1名です。追加人数は+¥1,000/名（最大4名）。プレミアム会員は基本2名（本人＋同伴1名）。3人目以降は+¥1,000/名（最大4名）。',
      },
      {
        q: '延長料金を教えてください。',
        a: 'サブスク会員の延長料金（1名あたり）：+1時間 ¥1,000 / +2時間 ¥1,800 / +3時間 ¥2,400。延長料金は「延長時間×利用人数」で計算されます。追加人数の料金とは別に発生します。ビジターの延長は+1時間につき¥5,000です。',
      },
      {
        q: '回数券について教えてください。',
        a: '10回綴り（1回＝55分）で¥40,000です。購入から3ヶ月有効。1名のみ利用可能で、延長はできません。予約は7日前から可能です。',
      },
      {
        q: 'サブスク入会金・入会手数料はかかりますか？',
        a: '現在はキャンペーン期間中のため無料です。ただし、再入会の際には入会手数料10,000円が必要です。',
      },
      {
        q: 'サブスクの月額利用回数に制限はありますか？',
        a: '月額利用回数に制限はありません。ただし、現在の予約を消化した後に次の予約が可能となります。1日の予約は1回までです。',
      },
      {
        q: '支払い方法は何に対応していますか？',
        a: 'クレジットカードのみです。施設内の物販はPayPayのみとなります。',
      },
      {
        q: '料金は税込ですか？',
        a: 'はい、すべて税込価格です。',
      },
    ],
  },
  {
    category: '予約について',
    items: [
      {
        q: '予約はどこからできますか？',
        a: '予約システム（https://tdbs.me/）からどうぞ。無料体験は公式LINEからご予約いただけます。',
      },
      {
        q: '予約可能なタイミングはいつからですか？',
        a: 'ビジター：前日0:00〜当日。ライト会員：3日前 0:00〜。プレミアム会員：7日前 0:00〜。回数券：7日前 0:00〜。',
      },
      {
        q: '予約の変更はできますか？',
        a: '予約サイトから変更可能です。ただし、当日キャンセルを複数回行うとアカウントが利用停止になる可能性があります。',
      },
      {
        q: '同じ日に複数回予約できますか？',
        a: 'いいえ。1日1回までです。ただし後ろの時間に空きがあれば、最大4時間まで延長可能です。',
      },
      {
        q: '次の予約はいつ取れますか？',
        a: '予約を消化する（利用する）まで、次の予約はお取りいただけません。',
      },
      {
        q: '時間の延長はどうすればいいですか？',
        a: '空きがある場合のみ可能です。予約サイトの会員情報から手続きできます。',
      },
      {
        q: '予定時刻より早く着いた場合は？',
        a: 'ドアはオートロックで、開場キーは利用時間にならないと有効になりません。前の方がいる場合は退室までお待ちください。',
      },
    ],
  },
  {
    category: '施設・設備について',
    items: [
      {
        q: '何名まで利用できますか？',
        a: '最大4名様までです。4名を超えるご利用は安全上の理由で固くお断りしています。',
      },
      {
        q: '手ぶらでも大丈夫ですか？',
        a: 'はい。ゴルフクラブ（男性用・女性用・キッズ用 ※右利き用のみ）とシューズ（22cm〜29cm）を無料レンタルいただけます。',
      },
      {
        q: '左利きにも対応していますか？',
        a: '打席は両打席対応です。ただし左利き用のレンタルクラブはありませんので、お持ち込みください。',
      },
      {
        q: '自分のクラブを持ち込めますか？',
        a: 'はい、もちろん可能です。',
      },
      {
        q: 'ボールやグローブは用意されていますか？',
        a: '現地で購入いただけます（PayPay決済）。こだわりのある方はご自身のものをお持ちください。',
      },
      {
        q: '飲食の持ち込みは可能ですか？',
        a: 'はい。施設内にもソフトドリンクやナッツなどの軽食をご用意しています。',
      },
      {
        q: 'アルコールは飲めますか？',
        a: 'イベント時以外の提供はありません。持ち込みは可能です。過度に泥酔した状態でのご利用はお断りしています。',
      },
      {
        q: '喫煙はできますか？',
        a: '完全禁煙です。喫煙が発覚した場合、アカウントを凍結します。',
      },
      {
        q: '更衣室はありますか？',
        a: 'はい。共有部に十分な広さの更衣室をご用意しております。',
      },
      {
        q: 'プレーしない同伴者も料金がかかりますか？',
        a: 'はい。同伴者無料枠を超える方は、プレーの有無・年齢に関わらず料金が必要です。',
      },
      {
        q: '身長制限はありますか？',
        a: '180cm以上の方はスイング時に頭上の梁にクラブが接触する場合があります。破損やお怪我の責任は負いかねます。',
      },
      {
        q: '機器を壊してしまった場合は？',
        a: '速やかに事務局へご連絡ください。機器破損により営業不能の場合、営業補償を請求することがあります。ゴルフ保険の加入をおすすめします。',
      },
      {
        q: 'Wi-Fiはありますか？',
        a: 'フリーWi-Fiをご用意しております。',
      },
      {
        q: 'トイレはありますか？',
        a: '同じ建物1階に男女兼用のお手洗いがあります。',
      },
    ],
  },
  {
    category: '機器・ソフトウェアについて',
    items: [
      {
        q: '機械は簡単に使えますか？',
        a: 'マニュアルを施設内に設置しております。不安な方はインストラクターオプション（¥3,300/時間）をご利用ください。',
      },
      {
        q: 'どんなシミュレーターを使っていますか？',
        a: 'UNEEKOR EYE XO2を設置しています。カメラによるスイング解析と高精度な弾道測定が可能な、プロも愛用するセンサーです。',
      },
      {
        q: 'コースは何種類ありますか？',
        a: 'GSProを使用しており、1700以上のコースが収録されています。実在のゴルフコースからファンタジーコースまで、コミュニティで作成・共有されており増え続けています。',
      },
      {
        q: 'AIレッスン機能とは何ですか？',
        a: 'デュアルカメラで正面と側面からスイングを撮影し、フォーム改善に必要なデータを測定する機能です。初回はインストラクターオプションの利用を推奨しています。',
      },
      {
        q: 'スイングデータはどのような項目が測定されますか？',
        a: '打ち出し角、スピン量、飛距離、クラブヘッドスピード、インパクト位置など、詳細なデータがリアルタイムで表示されます。',
      },
      {
        q: '測定データは保存されますか？',
        a: '現在は保存できません。今後、スマートフォンでの取込機能を実装予定です。',
      },
    ],
  },
  {
    category: '無料体験について',
    items: [
      {
        q: '無料体験とは何ですか？',
        a: '55分の完全無料体験で、世界最高峰のシミュレーターを実際に体感いただけます。公式LINEからお申し込みいただくだけで、デポジットも不要です。',
      },
      {
        q: '無料体験はどうやって申し込みますか？',
        a: '公式LINE（https://lin.ee/IX2y4CH）にご登録いただき、体験の希望日時を送信してください。日程を個別に調整いたします。',
      },
      {
        q: '無料体験は何回でもできますか？',
        a: '初回利用の方のみ対象です。',
      },
      {
        q: '無料体験には何を持っていけばいいですか？',
        a: '手ぶらでお越しいただけます。クラブ・シューズは無料レンタルをご用意しています。動きやすい服装でお越しください。',
      },
      {
        q: '無料体験の後、入会しなければいけませんか？',
        a: 'いいえ。体験後の入会は任意です。体験後にお得な限定特典をご案内しますが、無理な勧誘は一切行いません。',
      },
    ],
  },
  {
    category: 'サブスク会員について',
    items: [
      {
        q: 'サブスクの契約期間は？',
        a: '最低契約期間はございませんが、キャンペーン特典をご利用の場合は個別に契約期間を設定する場合があります。詳細は無料体験の際にスタッフまでお問い合わせください。',
      },
      {
        q: 'サブスクの退会方法は？',
        a: '公式LINEよりご連絡ください。退会は更新日の14日前までの受付です。それ以降は翌々更新日をもって解約となります。',
      },
      {
        q: 'サブスクの休会はできますか？',
        a: '休会制度はございません。',
      },
      {
        q: '契約者不在で同伴者だけの利用はできますか？',
        a: 'いいえ。契約者不在での利用はできません。不正利用が発覚した場合は会員権を剥奪します。',
      },
      {
        q: 'サブスク会員の利用枠を使い切った場合は？',
        a: 'ビジターとしてのご利用が可能です。予約画面の「ビジターで予約する」からお手続きください。予約可能期間はご契約プランに準じます。',
      },
    ],
  },
  {
    category: 'アクセス・駐車場',
    items: [
      {
        q: '場所はどこですか？',
        a: '大阪市住之江区中加賀屋２丁目８−１ 2F です。大阪メトロ四つ橋線「北加賀屋駅」1番出口より徒歩6分。',
      },
      {
        q: '入口がわかりません。',
        a: '幻たこ（たこ焼き屋）隣の個別対応指導の螢雪パーソナル住之江教室の2階です。商店街裏口のBOSS自販機横にGolph.clubの看板がある路地を進み、扉を開けて2階へお上がりください。',
      },
      {
        q: '駐車場はありますか？',
        a: '無料で3台分あります。縦列のため奥からご利用ください。速やかな出庫にご協力をお願いします。',
      },
      {
        q: '駐輪場はありますか？',
        a: '駐車場をご利用ください。施設前や道路への駐輪は近隣の迷惑となるため禁止です。',
      },
      {
        q: '営業時間は？',
        a: '6:00〜23:55です。',
      },
    ],
  },
  {
    category: 'その他',
    items: [
      {
        q: 'インストラクターオプションとは？',
        a: '技術指導ではなく、機器の使い方や測定数値の見方をお伝えするサポートです。¥3,300/時間。無料体験時の対応もインストラクターが担当します。',
      },
      {
        q: 'レッスン（技術指導）は受けられますか？',
        a: 'レッスンコーチの常駐はございません。ご自身で契約いただくか、弊社からの紹介も可能です。',
      },
      {
        q: 'イベントは開催されていますか？',
        a: 'はい。ホールインワンチャレンジなどを不定期で開催しています。公式LINEまたはお知らせページをご確認ください。',
      },
      {
        q: '法人利用はできますか？',
        a: '公式LINEよりご相談ください。条件を満たす方にご案内いたします。',
      },
      {
        q: 'ショールームの見学はできますか？',
        a: 'はい。UNEEKOR正規代理店・ショールームとして機能しています。お問い合わせフォームからご相談ください。',
      },
      {
        q: 'フランチャイズ加盟について知りたい。',
        a: 'お問い合わせフォームからご連絡ください。機器導入から店舗設計、予約システム、運用サポートまでワンストップで提供しています。',
      },
      {
        q: '問い合わせ方法は？',
        a: '公式LINE（https://lin.ee/IX2y4CH）よりご連絡ください。',
      },
    ],
  },
];



interface AccordionItemProps {
  faq: FaqItem;
  isOpen: boolean;
  onToggle: () => void;
}

function AccordionItem({ faq, isOpen, onToggle }: AccordionItemProps) {
  return (
    <div className="bg-white rounded-xl overflow-hidden border border-[#1a1a3e]/6 hover:border-[#e85d2c]/20 transition-all duration-200">
      <button
        className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
        onClick={onToggle}
      >
        <span className="text-[#1a1a3e] text-[15px] font-medium pr-4 leading-relaxed">{faq.q}</span>
        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
          <i
            className={`ri-${isOpen ? 'subtract' : 'add'}-line text-[#e85d2c] text-lg transition-transform duration-200`}
          ></i>
        </div>
      </button>
      <div
        className={`transition-all duration-300 overflow-hidden ${
          isOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <p
          className="px-6 pb-5 text-[#1a1a3e]/55 text-[15px] leading-[1.75]"
          style={{ wordBreak: 'auto-phrase' } as React.CSSProperties}
        >
          {faq.a}
        </p>
      </div>
    </div>
  );
}

export default function FAQ() {
  const [activeCategory, setActiveCategory] = useState(0);
  const [openKey, setOpenKey] = useState<string | null>(null);
  const { ref: headRef, isVisible: headVisible } = useScrollAnimation();
  const { ref: bodyRef, isVisible: bodyVisible } = useScrollAnimation(0.05);

  const handleCategoryChange = (idx: number) => {
    setActiveCategory(idx);
    setOpenKey(null);
  };

  const toggle = (key: string) => setOpenKey(openKey === key ? null : key);

  const currentItems = faqCategories[activeCategory]?.items ?? [];

  return (
    <section id="faq" className="py-24 bg-[#fafafa]">

      <div className="px-6 lg:px-20 max-w-3xl mx-auto">

        {/* Heading */}
        <div
          ref={headRef}
          className={`text-center mb-10 transition-all duration-[600ms] ease-out ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a1a3e]"
            style={{ fontFamily: "'Noto Serif JP', serif", textWrap: 'balance', wordBreak: 'auto-phrase' } as React.CSSProperties}
          >
            よくある質問。
          </h2>
        </div>

        {/* ── Category Tabs — flex-wrap で全表示 ── */}
        <div
          className={`transition-all duration-[700ms] ease-out mb-8 ${headVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
          style={{ transitionDelay: '150ms' }}
        >
          <div className="flex flex-wrap gap-2">
            {faqCategories.map((cat, i) => (
              <button
                key={i}
                onClick={() => handleCategoryChange(i)}
                className={`whitespace-nowrap text-[13px] font-semibold px-4 py-2 rounded-full transition-all duration-200 cursor-pointer ${
                  activeCategory === i
                    ? 'bg-[#e85d2c] text-white'
                    : 'bg-white border border-[#1a1a3e]/10 text-[#1a1a3e]/50 hover:text-[#e85d2c] hover:border-[#e85d2c]/30'
                }`}
              >
                {cat.category}
              </button>
            ))}
          </div>
        </div>

        {/* ── Accordion for active category ── */}
        <div
          ref={bodyRef}
          className={`transition-all duration-[500ms] ease-out ${bodyVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <div className="space-y-3">
            {currentItems.map((faq, itemIdx) => {
              const key = `${activeCategory}-${itemIdx}`;
              return (
                <AccordionItem
                  key={key}
                  faq={faq}
                  isOpen={openKey === key}
                  onToggle={() => toggle(key)}
                />
              );
            })}
          </div>

          {/* LINE CTA at bottom */}
          <div className="mt-12 text-center">
            <p className="text-[#1a1a3e]/40 text-[14px] mb-4">解決しない場合はお気軽にご連絡ください</p>
            <a
              href="https://lin.ee/IX2y4CH"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border-2 border-[#47d6d4] text-[#47d6d4] font-bold px-8 py-3 rounded-full text-[14px] hover:bg-[#47d6d4]/8 transition-all duration-200 whitespace-nowrap"
            >
              <i className="ri-line-fill text-lg"></i>
              公式LINEで問い合わせる
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}
